import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlass } from "@phosphor-icons/react";
import AdminLayout from "@/components/AdminLayout";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { naira, CATEGORY_LABEL } from "@/lib/format";

const catBadge = {
  new_standard: "bg-slate-100 text-slate-700",
  deposit: "bg-blue-50 text-blue-800",
  credit: "bg-[#0A4F35]/10 text-[#0A4F35]",
};

export default function AdminCustomers() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  const load = useCallback(async () => {
    const { data } = await api.get("/admin/customers", { params: q ? { q } : {} });
    setRows(data);
  }, [q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  return (
    <AdminLayout>
      <h1 className="font-display text-3xl font-bold text-slate-900">Customers</h1>

      <div className="mt-6 relative max-w-lg">
        <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <Input data-testid="customers-search" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search by company, phone or email" className="pl-10" />
      </div>

      <div className="mt-6 rounded-lg border border-[#E5E7EB] bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#E5E7EB] text-left text-xs uppercase tracking-widest text-slate-400">
              <th className="px-4 py-3">Company</th>
              <th className="px-4 py-3">Contact</th>
              <th className="px-4 py-3">Category</th>
              <th className="px-4 py-3 text-center">Orders</th>
              <th className="px-4 py-3 text-right">Outstanding</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E5E7EB]">
            {rows.map((c) => (
              <tr key={c.id} className="hover:bg-[#F9FAFB]">
                <td className="px-4 py-3">
                  <Link to={`/admin/customers/${c.id}`} data-testid={`customer-${c.id}`} className="font-semibold text-[#0A4F35] hover:underline">{c.company_name}</Link>
                </td>
                <td className="px-4 py-3 text-slate-600">{c.phone}<div className="text-xs text-slate-400">{c.email}</div></td>
                <td className="px-4 py-3"><span className={`rounded px-2 py-0.5 text-xs font-medium ${catBadge[c.payment_category]}`}>{CATEGORY_LABEL[c.payment_category]?.split(" ")[0] || c.payment_category}</span></td>
                <td className="px-4 py-3 text-center">{c.order_count}</td>
                <td className="px-4 py-3 text-right tabular-nums font-medium text-[#DC2626]">{c.outstanding > 0 ? naira(c.outstanding) : "—"}</td>
                <td className="px-4 py-3">{c.credit_blocked ? <span className="rounded bg-red-50 px-2 py-0.5 text-xs font-medium text-red-700">Blocked</span> : <span className="text-xs text-slate-400">Active</span>}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-400">No customers found.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
